import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c8093a7c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Toggle: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Toggle/index.vue').default,FilterToggle: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/FilterToggle/index.vue').default,SelectCheckBoxComponent: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/SelectCheckBoxComponent/index.vue').default,SelectSearchComponent: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/SelectSearchComponent/index.vue').default,DatePickerComponent: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/DatePickerComponent/index.vue').default,Button: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Button/index.vue').default})
